import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export default function useUnshareTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, string>({
    mutationFn: skillId => api.delete(`/tenant/custom-skills/${skillId}/share`),
    onSettled: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] }),
        queryClient.invalidateQueries({ queryKey: ['skill-library'] }),
      ]);
    },
  });
}
